import _ from 'lodash'
import moment from 'moment'

export default {
  updatePageState (state, data) {
    state.pageListReport = data
  },
  listCommit (state, data) {
    state.rangeReport.list = data

    state.rangeReport.listOptions = _.orderBy(_.map(data, function (e) {
      let fromDate = moment(e.from_date).format('DD/MM/YYYY')
      let toDate = moment(e.to_date).format('DD/MM/YYYY')
      let rawFromDate = moment(e.from_date).unix()
      return { id: e.id, value: e.id, text: `${fromDate} - ${toDate}`, label: `${fromDate} - ${toDate}`, rawFromDate }
    }), ['rawFromDate'], ['desc'])
  },
  pageDetailCommit (state, detail) {
    state.detailReport = detail
  },
  updateAutoReportSelectedAccount (state, selectedAccount) {
    state.autoReport.selected_account = selectedAccount
  }
}
